var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62786 22.5373C1.19531 13.0723 0 12.102 0 8.625C0 3.86328 3.80729 0 8.5 0C13.1927 0 17 3.86328 17 8.625C17 12.102 15.8047 13.0723 9.37214 22.5373C8.95156 23.1572 8.04844 23.1572 7.62344 22.5373H7.62786ZM8.5 12.2188C10.4568 12.2188 12.0417 10.6105 12.0417 8.625C12.0417 6.63945 10.4568 5.03125 8.5 5.03125C6.54323 5.03125 4.95833 6.63945 4.95833 8.625C4.95833 10.6105 6.54323 12.2188 8.5 12.2188Z",
    fill: "#476930"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.d38d98b8b26d57aa51d66eb0c3fba868.svg";
export { ForwardRef as ReactComponent };